import { useTranslation } from 'react-i18next';
import { Button } from '../../../ui/Button/index.js';
import { useGenerateThemeTitles } from '../../../../hooks/useSnsContentGenerator.js';
import type { GeneratedThemeTitle } from '../../../../hooks/useSnsContentGenerator.js';

export interface GenerateThemeTitlesButtonProps {
  /** 生成対象のアカウントID。URLの `$accountId` をそのまま渡す */
  accountId: string;
  /** 編集中リストに既にあるテーマ。重複回避のため生成ミューテーションに渡す */
  existingThemes: string[];
  /** 生成成功時のハンドラー */
  onGenerated: (items: GeneratedThemeTitle[]) => void;
  /** 生成失敗時のハンドラー */
  onError: (message: string) => void;
}

/**
 * @graph-stack cortex-admin
 * @graph-domain Marketing
 * @graph-business 「生成する」ボタン。useGenerateThemeTitlesのmutateを呼び、成否をコールバックで返す
 * @graph-connects useGenerateThemeTitles [calls] テーマ・タイトル生成ミューテーション呼び出し
 */
export function GenerateThemeTitlesButton({
  accountId,
  existingThemes,
  onGenerated,
  onError,
}: GenerateThemeTitlesButtonProps) {
  const { t } = useTranslation();
  const generateMutation = useGenerateThemeTitles();

  const handleClick = () => {
    generateMutation.mutate(
      { accountId, excludeThemes: existingThemes },
      {
        onSuccess: (items) => {
          onGenerated(items);
        },
        onError: () => {
          onError(t('snsContentGenerator.generateError'));
        },
      },
    );
  };

  return (
    <Button
      type="button"
      variant="primary"
      size="sm"
      onClick={handleClick}
      loading={generateMutation.isPending}
    >
      {generateMutation.isPending
        ? t('snsContentGenerator.generating')
        : t('snsContentGenerator.generate')}
    </Button>
  );
}
